package uk.co.nickthecoder.kyd

import uk.co.nickthecoder.glok.application.Application
import uk.co.nickthecoder.glok.application.GlokTimer
import uk.co.nickthecoder.glok.scene.Color
import uk.co.nickthecoder.kyd.util.Ticker

class Act {

    var title = ""

    var backgroundColor: Color = Color.BLACK

    val stages = mutableListOf<Stage>()

    var directorType: String = NoDirectorClassName
        set(v) {
            if (field != v) {
                field = v
                // TODO When directors have custom attributes, do we just trash the old values?
                director = KydTypeRegistry.createDirector(v)
            }
        }

    var director: Director = NoDirector
        private set

    /**
     * Runs as FAST as possible, we will be limited by [Application.idleFramePeriod]
     */
    private val tickTimer = GlokTimer(0.0, true) {
        Ticker.tick(this)
    }

    /**
     * Starts `ticking`. See [Ticker].
     * Called when this act is loaded by [Management.loadAct]
     */
    fun start() {
        Ticker.reset()
        tickTimer.start()
    }

    /**
     * Stops `ticking`. See [Ticker].
     *
     * Called when this act is replaced by a new one loaded by [Management.loadAct].
     * Also stopped when the game is terminated by [Management.terminate].
     */
    fun stop() {
        tickTimer.stop()
    }

    /**
     * Adds actors from [other] act's stages to this act's stages.
     */
    fun merge(other: Act) {
        for (otherStage in other.stages) {
            val thisStage = stages.firstOrNull { it.name == otherStage.name } ?: continue
            thisStage.addAll(otherStage.actors)
        }
    }

}
